import React from 'react';
import {useTranslation} from "react-i18next";

interface Props {
    id: string;
    fallback?: string;
    values?: Record<string, any>;
}
const IntlMessage = ({ id, fallback = 'Название кнопке не придумали', values}: Props) => {
    const { t } = useTranslation();

    // Правильный способ передачи параметров в react-i18next
    const options = values ? { defaultValue: fallback, ...values } : { defaultValue: fallback };
    const translate = t(id, options);
    const parts = translate.split('\n').map((part, index, array) => (
        <React.Fragment key={index}>
            {part}
            {index !== array.length - 1 && <br />} {/* Add <br /> except after the last part */}
        </React.Fragment>
    ));
    return <>{parts}</>;
};

export default IntlMessage;

export class IntlMessageText {
    static getText({ id, fallback, values }: Props) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { t } = useTranslation();
        const options = values ? { defaultValue: fallback, ...values } : { defaultValue: fallback };
        const translate = t(id, options);
        return translate;
    }
}